
<div class="auth-container">
    <div class="logo-login">
        <app-logo logoType="name"></app-logo>
    </div>
    <div class="auth-card" *ngIf="!passwordReset">
        <div class="auth-header">
           
            <div class="h6">Reset Password</div>
        </div>
        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="new-password">Enter new password<span class="required">*</span></label>
                <div class="input-container">
                    <input id="new-password" [type]="showPassword ? 'text' : 'password'" class="form-control" [ngClass]="{'error': password && password.invalid && (password.dirty || password.touched)}" placeholder="New password" formControlName="password">
                    <img [src]="showPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'" alt="Toggle password visibility" class="input-icon" (click)="togglePasswordVisibility()">
                </div>
                <div *ngIf="password && password.invalid && (password.dirty || password.touched)" class="error-message reset-error">
                    <div *ngIf="password.errors?.['required']">
                        Password is required.
                    </div>
                    <div *ngIf="password.errors?.['minlength']">
                        Password must be at least 8 characters.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="confirm-password">Confirm new password<span class="required">*</span></label>
                <div class="input-container">
                    <input id="confirm-password" [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" [ngClass]="{'error': confirmPassword && confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)}" placeholder="Repeat new password" formControlName="confirmPassword">
                    <img [src]="showConfirmPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'" alt="Toggle password visibility" class="input-icon" (click)="toggleConfirmPasswordVisibility()">
                </div>
                <div *ngIf="confirmPassword && confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" class="error-message reset-error">
                    <div *ngIf="confirmPassword.errors?.['required']">
                        Confirm password is required.
                    </div>
                </div>
                 <div *ngIf="confirmPassword?.errors?.['mismatch']" class="error-message reset-error">
                    Passwords don’t match.
                </div>
            </div>
            <button type="submit" class=" btn btn-primary btn-large" [ngClass]="{'disabled': resetForm.invalid || loading}" [disabled]="resetForm.invalid || loading">
                <span *ngIf="!loading">Reset Password</span>
                <span *ngIf="loading" class="loader"></span>
            </button>
            <div class="auth-footer">
                <a  routerLink="/login" class="btn btn-tertiary btn-small">Go Back to Log In</a>
            </div>
        </form>
    </div>
    <app-password-updated-message *ngIf="passwordReset"></app-password-updated-message>

</div>
